import React from 'react';
import cc from 'classcat';
import { Drawer as BPDrawer, DrawerProps } from '@blueprintjs/core';
import PortalContainerRef from '../../atoms/portal-container';

const Drawer: React.FC<DrawerProps> = (props): JSX.Element => {
  const classes = cc([props.className]);
  return (
    <BPDrawer
      {...props}
      className={classes}
      portalContainer={PortalContainerRef.current}
    />
  );
};

export default Drawer;
